import { useQueryClient } from '@tanstack/react-query'

import { useIndividualsServicePatchV1IndividualsByIndividualIdDocumentsByDocumentId } from '../client/queries'
import { useIndividualsServiceGetV1IndividualsByIndividualIdKey } from '../client/queries/common'

export const useRenameDocument = () => {
  const queryClient = useQueryClient()

  return useIndividualsServicePatchV1IndividualsByIndividualIdDocumentsByDocumentId({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useIndividualsServiceGetV1IndividualsByIndividualIdKey],
      })
    },
  })
}
